import type { FormatDateOptions } from '@leagueplatform/locales';
import {
  MasonryChartAggregationBucketType,
  MasonryChartInterval,
} from '#types/masonry-chart.type.ts';

/**
 * This map is used to format the date based on the interval selected. This will
 * eventually be replaced once the chart is migrated to CACT.
 */
export const intervalDateFormatMap: Record<
  MasonryChartInterval,
  FormatDateOptions
> = {
  weekly: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  monthly: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  yearly: {
    year: 'numeric',
    month: 'long',
  },
  '5-yearly': {
    year: 'numeric',
  },
};

/**
 * Format used in tooltips when the data is aggregated into buckets larger than
 * a single day. Granularity matches the bucket size.
 */
export const bucketDateFormatMap: Record<
  MasonryChartAggregationBucketType,
  FormatDateOptions
> = {
  daily: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  monthly: {
    year: 'numeric',
    month: 'long',
  },
  yearly: {
    year: 'numeric',
  },
};
